import _ from 'lodash'
import { Check, ChevronsUpDown } from 'lucide-react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { Button } from '@/components/elements/button'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/elements/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/elements/popover'
import { cn } from '@/utils/helpers'

const MultiSelect = ({
  options,
  onChange,
  placeholder = 'Select an Option',
  value = [],
  width = '',
  id = '',
  ...rest
}) => {
  // State
  const [open, setOpen] = useState(false)

  const valueLabels = _.map(
    options.filter((option) => value.includes(option.id)),
    'label',
  ).join(', ')

  return (
    <Popover open={open} onOpenChange={setOpen} modal {...rest}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          id={id}
          role="combobox"
          aria-expanded={open}
          className={cn('w-[200px] justify-between', width)}
        >
          <span
            className={cn(
              'w-full truncate text-start',
              value.length > 0 ? 'text-foreground' : 'text-muted-foreground',
            )}
          >
            {value.length > 0 ? valueLabels : placeholder}
          </span>
          <ChevronsUpDown className="min-w-auto shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn('w-[200px] p-0', width)}>
        <Command
          filter={(v, search) => {
            if (!search) return true
            return options
              .find((o) => o.id === v)
              .label.toLowerCase()
              .includes(search.toLowerCase())
          }}
        >
          <CommandInput placeholder="Search option..." className="h-9" />
          <CommandList>
            <CommandEmpty>No option found.</CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.id}
                  value={option.id}
                  onSelect={(currentValue) => {
                    onChange(
                      value.includes(currentValue)
                        ? value.filter((v) => v !== currentValue)
                        : [...value, currentValue],
                    )
                  }}
                >
                  {option.label}
                  <Check
                    className={cn(
                      'ml-auto',
                      value.includes(option.id) ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.array,
  width: PropTypes.string,
  id: PropTypes.string,
}

export default MultiSelect
